import { create } from 'zustand';
import { Person, Machine, Material, Product, Workflow } from '@/types';

interface ResourceState {
  persons: Person[];
  machines: Machine[];
  materials: Material[];
  products: Product[];
  workflows: Workflow[];

  // Actions
  setPersons: (persons: Person[]) => void;
  setMachines: (machines: Machine[]) => void;
  setMaterials: (materials: Material[]) => void;
  setProducts: (products: Product[]) => void;
  setWorkflows: (workflows: Workflow[]) => void;

  // Getters
  getPersonById: (id: string) => Person | undefined;
  getMachineById: (id: string) => Machine | undefined;
  getMaterialById: (id: string) => Material | undefined;
  getProductById: (id: string) => Product | undefined;
  getWorkflowById: (id: string) => Workflow | undefined;

  // Utility getters
  getAvailablePersons: () => Person[];
  getAvailableMachines: () => Machine[];
  getLowStockMaterials: () => Material[];
}

export const useResourceStore = create<ResourceState>((set, get) => ({
  // Initial state
  persons: [],
  machines: [],
  materials: [],
  products: [],
  workflows: [],

  // Setters
  setPersons: (persons) => set({ persons }),
  setMachines: (machines) => set({ machines }),
  setMaterials: (materials) => set({ materials }),
  setProducts: (products) => set({ products }),
  setWorkflows: (workflows) => set({ workflows }),

  // Getters
  getPersonById: (id) => get().persons.find((person) => person.id === id),
  getMachineById: (id) => get().machines.find((machine) => machine.id === id),
  getMaterialById: (id) => get().materials.find((material) => material.id === id),
  getProductById: (id) => get().products.find((product) => product.id === id),
  getWorkflowById: (id) => get().workflows.find((workflow) => workflow.id === id),

  // Utility getters
  getAvailablePersons: () =>
    get().persons.filter((person) => person.status === '啟用'),

  getAvailableMachines: () =>
    get().machines.filter(
      (machine) => machine.status === '啟用' && machine.maintenanceStatus === '正常'
    ),

  getLowStockMaterials: () =>
    get().materials.filter(
      (material) => material.stockQuantity <= material.safetyStock
    ),
}));
